/**
 * Слайдшоу
 */
class Slideshow
{
	/**
	 * Событие смены слайда
	 */
	public static readonly EVENT_CHANGE = 'slideshow:change';
	/**
	 * Класс, назначаемый текущему слайду
	 */
	public static readonly CLASS_SLIDE_CURRENT = 'current';
	/**
	 * Класс, назначаемый предыдущему слайду
	 */
	public static readonly CLASS_SLIDE_PREV = 'prev';
	
	/**
	 * Элемент с дочерними элементами-слайдами
	 */
	private slidesList: HTMLElement;
	/**
	 * Номер текущего слайда
	 */
	private slideIndex: number = 0;
	/**
	 * Номер предыдущего слайда
	 */
	private prevSlideIndex: number = 0;
	/**
	 * ID таймера автолистания
	 */
	private timer: number = 0;
	/**
	 * Задержка между слайдами, ms
	 */
	private timerDelay: number = 0;
	
	/**
	 * Слайдшоу
	 * 
	 * @param slidesList Элемент с дочерними элементами-слайдами
	 */
	public constructor( slidesList: HTMLElement )
	{
		this.slidesList = slidesList;
	}
	
	/**
	 * Переход к указанному слайду
	 * 
	 * @param index Номер слайда
	 */
	public toSlide( index: number ): void
	{
		this.resetAutoSlideshow();
		
		const slides = this.slidesList.children;
		const count = slides.length;
		let newIndex: number = index;
		
		if ( newIndex >= count )
		{
			newIndex %= count;
		}
		else if ( newIndex < 0 )
		{
			newIndex = count + (newIndex % count);
		}
		
		const currentSlide = slides[this.slideIndex];
		const prevSlide = slides[this.prevSlideIndex];
		const newSlide = slides[newIndex];
		
		if ( prevSlide )
		{
			prevSlide.classList.remove( Slideshow.CLASS_SLIDE_PREV );
		}
		
		if ( currentSlide )
		{
			currentSlide.classList.remove( Slideshow.CLASS_SLIDE_CURRENT );
			currentSlide.classList.add( Slideshow.CLASS_SLIDE_PREV );
		}
		
		if ( newSlide )
		{
			newSlide.classList.add( Slideshow.CLASS_SLIDE_CURRENT );
			newSlide.classList.remove( Slideshow.CLASS_SLIDE_PREV );
		}
		
		this.slidesList.dispatchEvent(
			new CustomEvent(
				Slideshow.EVENT_CHANGE,
				{
					bubbles: true,
					cancelable: true,
					detail: {
						currentSlide: newIndex,
						prevSlide: this.slideIndex,
						slidesCount: count,
					} as SlideshowChangeEventDetails,
				},
			),
		);
		
		this.prevSlideIndex = this.slideIndex;
		this.slideIndex = newIndex;
	}
	
	/**
	 * Переход к следующему слайду
	 */
	public next(): void
	{
		this.toSlide( this.slideIndex + 1 );
	}
	
	/**
	 * Переход к предыдущему слайду
	 */
	public prev(): void
	{
		this.toSlide( this.slideIndex - 1 );
	}
	
	/**
	 * Установить автоматическое переключение слайдов
	 * 
	 * @param delay Задержка между слайдами, ms
	 */
	public autoSlideshow( delay: number ): void
	{
		this.timerDelay = delay;
		this.resetAutoSlideshow();
	}
	
	/**
	 * Сбросить параметры таймера автоматического переключения слайдов
	 */
	private resetAutoSlideshow(): void
	{
		this.stopAutoSlideshow();
		
		if ( this.timerDelay > 0 )
		{
			this.timer = setTimeout( () => this.next(), this.timerDelay );
		}
	}
	
	/**
	 * Остановить таймер автоматического переключения слайдов
	 */
	private stopAutoSlideshow(): void
	{
		if ( this.timer )
		{
			clearTimeout( this.timer );
		}
	}
}

/**
 * Дополнительные данные в объекте события смены слайда
 */
interface SlideshowChangeEventDetails
{
	/** Номер текущего слайда */
	readonly currentSlide: number;
	/** Номер предыдущего слайда */
	readonly prevSlide: number;
	/** Общее количество слайдов */
	readonly slidesCount: number;
}

/**
 * Объект события смены слайда
 */
interface SlideshowChangeEvent extends CustomEvent
{
	/** Дополнительные данные в объекте события смены слайда */
	readonly detail: SlideshowChangeEventDetails;
}

/**
 * Module
 */
export {
	Slideshow as default,
	SlideshowChangeEvent,
};



// WEBPACK FOOTER //
// ./app/elements/Slideshow.ts